import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { landing } from "@/lib/mockData";

export default function FaqSection() {
  return (
    <section
      data-testid="faq-section"
      id="faq"
      className="px-5 py-24 md:px-8 md:py-32"
    >
      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-12 lg:grid-cols-[1fr_2fr]">
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.5 }}
        >
          <div className="eyebrow">FAQ</div>
          <h2 className="mt-3 text-[36px] font-black leading-[1.02] tracking-tight text-zinc-900 md:text-[52px]">
            Honest<br />questions.<br />Honest answers.
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.5, delay: 0.1 }}
          className="card-soft rounded-[28px] p-2 md:p-4"
        >
          <Accordion type="single" collapsible className="w-full">
            {landing.faqs.map((f, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                data-testid={`faq-item-${i}`}
                className="border-b border-black/[0.04] last:border-b-0"
              >
                <AccordionTrigger className="px-3 py-4 text-left text-[15px] font-bold text-zinc-900 hover:no-underline md:text-[16px]">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="px-3 pb-4 text-[14px] leading-relaxed text-zinc-600">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
}
